import { v4 as uuid } from 'uuid';
import { CustomPageConfigurationType, CustomPageType } from '../../../api/custom-pages.dao';
import { PageID } from './index';

type EntityProps = Exclude<CustomPageConfigurationType, 'customPageId' | 'type'>;

const _props = Symbol('dto props');

export class CustomPageEntity {
    public static create(props: CustomPageConfigurationType): CustomPageEntity {
        const { customPageId = uuid(), type, ...rest } = props;

        if (!type) throw new Error('Custom Page Type is required');

        return new CustomPageEntity(customPageId, type, rest as CustomPageConfigurationType);
    }

    public toDTO(): CustomPageConfigurationType {
        const dto = this.getProps();
        dto.type = this.getType();

        if (this.persistent) {
            dto.customPageId = this.getId() as number;
        } else {
            delete dto.customPageId;
        }

        return dto;
    }

    public getType(): CustomPageType {
        return this.type;
    }
    public getId(): PageID {
        return this.id;
    }
    public getProps(): EntityProps {
        return { ...this[_props] };
    }

    public equalsTo(other: CustomPageEntity): boolean {
        return this.getId() === other.getId();
    }

    public isPagePathEqual(path: string): boolean {
        return this.getProps().path === path;
    }

    public get persistent(): boolean {
        return this.id ? typeof this.id === 'number' : false;
    }

    private constructor(private readonly id: PageID, private readonly type: CustomPageType, props: CustomPageConfigurationType) {
        this[_props] = props;
    }
    private readonly [_props]: EntityProps;
}
